// @shared-compat: both Admin and Client Task workspaces consume the same Airtable status vocabulary.
/** The one status vocabulary used by Airtable-backed Tasks and Projects. */
export const TASK_STATUS_OPTIONS = [
  'Draft',
  'Open',
  'In Progress',
  'Internal Review',
  'Review',
  'On Hold',
  'Done',
  'Closed',
  'Archived',
] as const;

export type TaskStatus = (typeof TASK_STATUS_OPTIONS)[number];

const TASK_STATUS_BY_KEY = new Map<string, TaskStatus>(
  TASK_STATUS_OPTIONS.map((status) => [status.toLowerCase(), status]),
);

/**
 * Normalize legacy casing and the old paused label without rejecting an
 * unknown Airtable value. Writes use this before reaching Airtable; reads use
 * it so old rows render with the canonical label while migration is pending.
 */
export function canonicalTaskStatus(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (trimmed.toLowerCase() === 'paused') return 'On Hold';
  if (trimmed.toLowerCase() === 'archived / closed') return 'Archived';
  return TASK_STATUS_BY_KEY.get(trimmed.toLowerCase()) ?? trimmed;
}

/** Obsolete select option found in the checked-in One Up Airtable schema. */
export const OBSOLETE_AIRTABLE_TASK_STATUS = {
  value: 'in progress',
  replacement: 'In Progress',
} as const;
